import { render, staticRenderFns } from "./AssistRecord.vue?vue&type=template&id=9bb75b02&scoped=true&"
import script from "./AssistRecord.vue?vue&type=script&lang=js&"
export * from "./AssistRecord.vue?vue&type=script&lang=js&"
import style0 from "./AssistRecord.vue?vue&type=style&index=0&id=9bb75b02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb75b02",
  null
  
)

export default component.exports